<template>
  <div class="f_o p_t p_b">
    <TopHead title="确认订单"></TopHead>
    <!--倒计时-->
    <div class="time_out d_f ali_c j_s">
      <div class="num">
        <div>剩余名额</div>
        <div class="num_d">仅剩<span>{{stockInfo.stockNum}}</span>人</div>
      </div>
      <div class="time t_a">
        <template v-if="isCutDown">
          <div>剩余支付时间</div>
          <van-count-down :time="time" />
        </template>
        <div v-else>已失效</div>
      </div>
    </div>

    <div class="o_top_card">
      <div class="d_f tag_out">
        <div class="tag" :style="{backgroundColor : info.bgColor}">{{info.commodityTypeName}}</div>
        <span class="flex_1">{{info.commodityName}}</span>
      </div>
      <div class="pri_out d_f ali_b j_s">
        <span>
          <span>{{stockInfo.startTime.split(' ')[0]+'——'+stockInfo.endTime.split(' ')[0]}}</span> ·
          <!--共<span>{{count(stockInfo.startTime,stockInfo.endTime)}}</span>天 ·-->
          共<span>{{info.duration}}</span> ·
          <span>{{stockInfo.displayName}}</span>
        </span>
        <div>
          <div class="price_sub" v-if="orderType == 1"><span>{{info.guardianNum}}</span>大<span>{{info.studentNum}}</span>小</div>
        </div>
      </div>
      <div class="item_d">
        <div class="d_f ali_c j_s">
          <span>课程单价</span>
          <span>￥<span>{{sellPrice ? sellPrice/100/sellNum : 0}}</span></span>
        </div>
        <div class="d_f ali_c j_s">
          <span>数量</span>
          <span>X <span>{{sellNum}}</span></span>
        </div>
        <div class="d_f ali_c j_s">
          <span>应付金额</span>
          <span>￥<span>{{sellPrice ? sellPrice/100 : 0}}</span></span>
        </div>
      </div>
    </div>
    <!--订单编号-->
    <div class="or_num">
      <div class="d_f ali_c j_s">
        <div>订单编号</div>
        <div>{{orderNo}}</div>
      </div>
      <div class="d_f ali_c j_s">
        <div>订单创建时间</div>
        <div>{{orderInfo.createTime}}</div>
      </div>
    </div>

    <!--预订人信息-->
    <div class="order_per">
      <div class="op_title d_f ali_c">
        <span>预订人信息</span>
      </div>
      <div class="items d_f ali_c">
        <span>中文名字</span>
        <span class="input">{{linkmenName}}</span>
      </div>
      <div class="items d_f ali_c b_n">
        <span>电话号码</span>
        <span class="input">{{telephone}}</span>
      </div>
    </div>


    <!--报名人信息亲子类-->
    <div v-if="orderType == 1" class="per_info">
      <div class="per_top d_f ali_b j_s">
        <div class="ti">报名人信息</div>
      </div>
      <div>
        <div class="per_item d_f ali_c text_out" v-for="(item,index) in orderInfo.applicantList" :key="index">
          <div class="name">{{item.applicantType == 1 ? '学生' : '家长'}}</div>
          <div class="flex_1 text">
            <div class="bb d_f ali_c j_s">
              <span>{{item.applicantName}}</span>
            </div>
            <div class="d_f ali_c j_s">
              <span>{{item.cardNo}}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!--报名人信息非亲子类-->
    <div v-else class="per_info">
      <div class="per_top d_f ali_b j_s">
        <div class="ti">学生报名信息</div>
      </div>
      <div>
        <div class="per_item d_f ali_c text_out" v-for="(item,index) in orderInfo.detailList" :key="index">
          <div class="name">学生{{index+1}}</div>
          <div class="flex_1 text">
            <div class="bb d_f ali_c j_s">
              <span>{{item.applicantName}}</span>
            </div>
            <div class="d_f ali_c j_s">
              <span>{{item.cardNo}}</span>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!--支付方式-->
    <div class="per_pay">
      <div class="p_title">支付方式</div>
      <div class="d_f ali_c">
        <img src="../assets/img/wechat.png" alt="" class="we">
        <span class="flex_1">微信支付</span>
        <img src="../assets/img/pay_check.png" alt="">
      </div>
    </div>

    <!--底部按钮-->
    <div class="bottom_btn p_f">
      <div class="price">
        ￥<span>{{sellPrice ? sellPrice/100 : 0}}</span>
      </div>
      <div class="flex_1 sub_text">
        <span v-if="orderType == 1">仅限<span>{{info.guardianNum}}</span>大<span>{{info.studentNum}}</span>小</span>
      </div>
      <div class="btn" @click="payOrder">确认支付</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SureOrder",
    data() {
      return {
        time:30 * 60 * 60 * 1000,
        info:'',
        stockInfo:{startTime:'',endTime:''},
        orderType:this.$route.query.orderType,
        sellNum:this.$route.query.sellNum,
        sellPrice:this.$route.query.sellPrice,
        orderNo:this.$route.query.orderNo,
        orderId:this.$route.query.orderId,
        linkmenName:this.$route.query.linkmenName,
        telephone:this.$route.query.telephone,
        isCutDown:true,
        orderInfo:{detailList:[]},
        interVal:null,
      }
    },
    created(){
      this.getCommodityStock();
      this.getCommodity();
      this.orderQuery();
    },
    onBeforeRouteLeave(){
      window.clearInterval(this.interVal);
      this.interVal = null;
    },
    methods: {
      //查询订单详情
      orderQuery(){
        this.$api.orderQuery({orderId:this.orderId}).then(res => {
          this.orderInfo = res.data;
          let now = new Date().getTime();
          let order = new Date(this.$renderTime(this.orderInfo.createTime)).getTime();
          if((order + 15 * 60 * 1000)>now){
            this.time = (order + 15 * 60 * 1000) - now;
          }else{
            this.isCutDown = false;
          }
        })
      },
      getOrderStatus(){
        this.$api.orderInfoQuery({orderId:this.orderId}).then(res => {
          if(res.data.showStatus == 6){
            let totalPrice = this.sellPrice ?　this.sellPrice/100 : 0;
            window.clearInterval(this.interVal);
            this.interVal = null;
            this.$router.push('/PaySuccess?totalPrice='+totalPrice+'&orderId='+this.orderId)
          }
        })

      },
      //确认支付
      payOrder(){
        this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: '支付中'
        });
        this.$api.payOrder({orderId:this.orderId,payChannel:'1',totalPrice:this.sellPrice}).then(res => {
          let info = this.jsonInfo(res.data.formData);
          this.payWechat(info)
        }).catch(err => {
          Toast(err.message);
          window.clearInterval(this.interVal);
          this.interVal = null;
        });
      },
      payWechat(info){
        let _t = this;
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
          }else if (document.attachEvent){
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
          }
        }else{
          onBridgeReady();
        }
        function onBridgeReady(){
          _t.interVal = setInterval(function () {
            _t.getOrderStatus()
          },1000);
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest', info,
            function(res){
              _t.$toast.clear();
              if(res.err_msg == "get_brand_wcpay_request:ok" ){
                setTimeout(function () {
                  window.clearInterval(_t.interVal);
                  clearInterval(_t.interVal);
                  _t.interVal = null;
                },10000)
                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              }
            });
        }
      },
      jsonInfo(c){
        let jsonData={};
        c=c.replace("{","").replace("}","");
        c=c.split(',');
        for(let i=0;i<c.length;i++){
          if(c[i].split('=').length === 2){
            jsonData[(c[i].split('=')[0]).replace(/\s+/g,"")]=(c[i].split('=')[1]).replace(/\s+/g,"")
          }else{
            let str = '';
            for(let j = 1;j<c[i].split('=').length;j++){
              str += (c[i].split('=')[j]).replace(/\s+/g,"")+'=';
            }
            jsonData[(c[i].split('=')[0]).replace(/\s+/g,"")]=(str.substring(0,str.length-1))
          }
        }
        return jsonData
      },
      //查询商品详情
      getCommodity(){
        this.$api.getCommodity({commodityId:this.$route.query.commodityId}).then(res => {
          this.info = res.data;
        })
      },
      //计算日期之间相差多少天
      count(d1,d2){
        let date1=new Date(d1);
        let date2=new Date(d2);
        let date=(date2.getTime()-date1.getTime())/(1000*60*60*24);/*不用考虑闰年否*/
        return date
      },
      //查询库存
      getCommodityStock(){
        this.$api.getCommodityStock({commodityId:this.$route.query.commodityId}).then(res => {
          let id = this.$route.query.stockId;
          res.data.map(item => {
            if(item.stockId == id){
              this.stockInfo = JSON.parse(JSON.stringify(item))
            }
          })
        })

      },
    }
  }
</script>

<style scoped lang="scss">
  .f_o{
    background-color: #F0F0F0;
    >div:not(.p_f){
      background-color: white;
    }
  }
  .time_out{
    .time{
      .van-count-down{
        font-size: 18px;
        font-weight: bold;
        color: #EF3C3C;
        margin-top: 8px;
      }
    }
    .num{
      .num_d{
        span{
          font-size: 18px;
          color: #EF3C3C;
          font-weight: bold;
        }
        margin-top: 6px;
      }
    }
    font-size: 14px;
    font-weight: 500;
    color: #3E3E3E;
    padding: 27px 13px 14px;
    border-bottom: 4px solid #F0F0F0;
  }

</style>
